<template>
  <div
    class="detail_main">
    <div @click="$parent.show = false" class="detail_container"
     :class="{'bg_detail': bg}">
    </div>
      <section
        class="size_detail
          zero_right
          margin_top_detail
          padding_bottom_detail
          has-background-white
          is-scrollable">
        <div class="columns is-marginless detail_content detail_content_bg">
          <div class="half_width detail_img_info">
            <a class="button has-text-white is-rounded diapo_button"
              @click="show = true">
              <p class="p_size14">Diaporama</p>
            </a>
            <img :src="url" class="imageBgOpp imgGoToTop">
          </div>
          <div class="half_width topVert leftVert rightVert">
            <a @click="$parent.show = false"
              class="detail_icon_close_right">
              <b-icon
                icon="window-close"
                size="">
              </b-icon>
            </a>
            <h3 class="has-text-link has-text-weight-bold bottomViolet">
              Proposition:</h3>
            <div class="bottomViolet">
              <div class="media color-icon">
                <b-icon
                  icon="timer"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content has-text-link is-size-7">
                    <label class=" has-text-grey">
                      Période d'affichage :
                    </label><br>
                    <p class="p_size14 has-text-weight-bold">
                      {{periode}}
                    </p>
                </div>
              </div>
            </div>
            <div class="columns is-marginless is-multiline color-icon detail_content_propo">
              <div
                v-if="detailFace.extensionOpportunite.tarifHT"
                class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="cash"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-link is-size-7">
                    <label class=" has-text-grey">
                      Tarif brut HT
                    </label><br>
                    <p class="p_size14 has-text-weight-bold">
                      {{calTarif(detailFace.extensionOpportunite.tarifHT)}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailFace.extensionOpportunite.tarifNet"
                class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="cash"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-link is-size-7">
                    <label class=" has-text-grey">
                      Tarif net HT
                    </label><br>
                    <p class="p_size14 has-text-weight-bold">
                      {{calTarif(detailFace.extensionOpportunite.tarifNet)}}
                    </p>
                    <span class="has-text-grey is-italic"
                      v-if="detailFace.extensionOpportunite.masquerRemiseEdition === true
                        && this.detailFace.extensionOpportunite.remise">
                      {{this.detailFace.extensionOpportunite.remise}} {{typeRemise}}
                    </span>
                  </div>
                </div>
              </div>
              <div
                v-if="detailFace.extensionOpportunite.tarifDePose  "
                class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="sign-text"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-link is-size-7">
                    <label class=" has-text-grey">
                      {{getLibelleTarifPose}}
                    </label><br>
                    <p class="p_size14 has-text-weight-bold">
                      {{calTarif(detailFace.extensionOpportunite.tarifDePose)}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailFace.extensionOpportunite.tarifImpression"
                class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="printer"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-link is-size-7">
                    <label class=" has-text-grey">
                      Tarif d'impression HT
                    </label><br>
                    <p class="p_size14 has-text-weight-bold">
                      {{calTarif(detailFace.extensionOpportunite.tarifImpression)}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailFace.extensionOpportunite.taxeMunicipale"
                class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="ballot"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-link is-size-7">
                    <label class=" has-text-grey">
                      Taxes municipales
                    </label><br>
                    <p class="p_size14 has-text-weight-bold">
                      {{calTarif(detailFace.extensionOpportunite.taxeMunicipale)}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailFace.extensionOpportunite.fraisTecniques"
                class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="panorama-wide-angle"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-link is-size-7">
                    <label class=" has-text-grey">
                      Frais techniques
                    </label><br>
                    <p class="p_size14 has-text-weight-bold">
                      {{calTarif(detailFace.extensionOpportunite.fraisTecniques)}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailFace.extensionOpportunite.facesSouhaitees"
                class="column is-6 is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="panorama-wide-angle"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-link is-size-7">
                    <label class=" has-text-grey">
                      Faces souhaitées
                    </label><br>
                    <p class="p_size14 has-text-weight-bold">
                      {{detailFace.extensionOpportunite.facesSouhaitees}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="detailFace.extensionOpportunite.commentaire">
              <h3
                class="has-text-link has-text-weight-bold topViolet">
                Commentaire:</h3>
              <div class="commentaire is-flex">
                <p class="has-text-link has-text-justify p_size14 mb-btnaction">
                  {{detailFace.extensionOpportunite.commentaire}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-block detail_content_2
                    topViolet rightVert leftVert bottomVert">
          <div class="column is-paddingless">
            <h3 class="has-text-link has-text-weight-bold bottomVert">
              Caractéristiques:</h3>
              <label class="has-text-grey">
                Nom du réseau
              </label>
              <p class="p_size14 has-text-weight-bold bottomViolet">
                {{detailFace.libelle}}
              </p>
            <div class="columns is-multiline color-icon">
              <div class="column">
                <div class="media">
                  <b-icon
                    icon="city"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-link is-size-7">
                    <label class="has-text-grey ">
                      Ville
                    </label><br>
                    <p class="p_size14 has-text-weight-bold">
                      {{detailFace.ville}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="media">
                  <b-icon
                    icon="vector-intersection"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-link is-size-7">
                    <label class="has-text-grey ">
                      Format
                    </label><br>
                    <p class="p_size14 has-text-weight-bold">
                      {{detailFace.format}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="media">
                  <b-icon
                    icon="sign-text"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-link is-size-7">
                    <label class=" has-text-grey">
                      Nombre de faces
                    </label><br>
                    <p class="p_size14 has-text-weight-bold">
                      {{detailFace.extensionOpportunite.facesSouhaitees}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="media">
                  <b-icon
                    icon="calendar"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content has-text-link is-size-7">
                    <label class="has-text-grey ">
                      Jour de depart
                    </label><br>
                    <p class="p_size14 has-text-weight-bold">
                      {{jour[detailFace.jourDepart]}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column topRouge bottomVert is-4 is-offset-8">
            <div
              v-if="!detailFace.select"
              @click="contolSelect()"
              class="topVert rightVert"
            >
              <a class="button is-primary is-rounded p_size14">Ajouter à ma sélection</a>
            </div>
            <div
              v-else
              @click="contolSelect()"
              class="topVert rightVert"
            >
              <a class="button boutonRed has-text-white is-rounded p_size14">
                Retirer de ma sélection</a>
            </div>
          </div>
        </div>
      </section>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      :duration="1000">
      <app-diapo-tempo
        :detailTem="detailFace.listeFaces"
        :reseau="detailFace.libelle"
        v-if="show"/>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { calPeriode, urlPhoto, formatNum, jrSem } from '@/services/opportunite/formatTab';
import diapoTempo from './diapoTempo';

export default {
  name: 'detailTempoDiapo',
  props: ['detailFace', 'bg', 'idOpportunite'],
  data() {
    return {
      show: false,
      hoverButton: false,
    };
  },
  components: {
    appDiapoTempo: diapoTempo,
  },
  computed: {
    url() {
      return urlPhoto(this.detailFace.urlPhoto);
    },
    periode() {
      if (this.detailFace.extensionOpportunite.newPeriode) {
        return this.detailFace.extensionOpportunite.newPeriode;
      }
      const d = this.detailFace.extensionOpportunite.jourDepart;
      const w = this.detailFace.extensionOpportunite.semaine;
      const y = this.detailFace.extensionOpportunite.annee;
      return calPeriode(d, w, y);
    },
    getLibelleTarifPose() {
      const decoded = atob(this.idOpportunite);
      if (!decoded) return false;
      const decodedObject = JSON.parse(decoded);
      if (!Object.prototype.hasOwnProperty.call(decodedObject, 'Site')) return 'Frais de pose HT';
      if (decodedObject.Site === 'sopa') return 'FPEA';
      return 'Frais de pose HT';
    },
    jour() {
      return jrSem;
    },
    typeRemise() {
      if (this.detailFace.extensionOpportunite.typeDeRemise === 0) {
        return '% de remise inclus';
      }
      return '€ de remise inclus';
    },
    getTarif() {
      let tarifNet = 0;
      let tarifDePose = 0;
      let taxeMunicipale = 0;
      let tarifImpression = 0;
      let tarifHT = 0;
      if (this.detailFace.extensionOpportunite.tarifDePose) {
        tarifDePose = this.detailFace.extensionOpportunite.tarifDePose;
      }
      if (this.detailFace.extensionOpportunite.taxeMunicipale) {
        taxeMunicipale = this.detailFace.extensionOpportunite.taxeMunicipale;
      }
      if (this.detailFace.extensionOpportunite.tarifImpression) {
        tarifImpression = this.detailFace.extensionOpportunite.tarifImpression;
      }
      if (this.detailFace.extensionOpportunite.tarifHT) {
        tarifHT = this.detailFace.extensionOpportunite.tarifHT;
      }
      if (this.detailFace.extensionOpportunite.tarifNet) {
        tarifNet = this.detailFace.extensionOpportunite.tarifNet;
        return tarifNet
        + tarifDePose
        + taxeMunicipale
        + tarifImpression;
      }
      return tarifHT
        + tarifDePose
        + taxeMunicipale
        + tarifImpression;
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect() {
      this.detailFace.select = !this.detailFace.select;
      if (this.detailFace.select) {
        this.add(this.getTarif);
        this.addNbSelect();
      } else {
        this.substract(this.getTarif);
        this.substractNbSelect();
      }
    },
    calTarif(t) {
      return formatNum(t);
    },
    close() {
      this.$parent.show = false;
    },
  },
  mounted() {
    const test = document.querySelector('html');
    test.style.overflow = 'hidden';
  },
  destroyed() {
    const test = document.querySelector('html');
    test.style.overflow = '';
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxTempo/detailTempoDiapo.vue